import { render, staticRenderFns } from "./UserAccountDetails.vue?vue&type=template&id=9813d090&"
import script from "./UserAccountDetails.vue?vue&type=script&lang=js&"
export * from "./UserAccountDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports